import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["width", "style", "className"];
import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import React, { useContext, useMemo, forwardRef } from 'react';
import { useStyles, StyleSheet } from '@rexlabs/styling';
import Box from '@rexlabs/box';
import { cx } from 'emotion';
import GridContext from './context';
var defaultStyles = StyleSheet({
  container: {
    width: '100%'
  }
});
var Column = /*#__PURE__*/forwardRef(function Column(_ref, ref) {
  var width = _ref.width,
      style = _ref.style,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      props = _objectWithoutProperties(_ref, _excluded);

  var s = useStyles(defaultStyles, 'Column');

  var _useContext = useContext(GridContext),
      gutter = _useContext.gutter,
      columns = _useContext.columns;

  var padding = typeof gutter === 'number' ? gutter / 2 : "calc(".concat(gutter, "/2)"); // In order to implement responsive styles we want to use StyleSheet
  // memoized towards the passed in widths, to allow inline objects we stringify
  // the width prop here!
  // TODO: Fix type
  // eslint-disable-next-line
  // @ts-ignore

  var memWidth = width !== null && width !== void 0 && width.default ? _JSON$stringify(width) : width;
  var styles = useMemo(function () {
    var _context;

    return StyleSheet({
      // TODO: Fix type
      // eslint-disable-next-line
      // @ts-ignore
      box: width !== null && width !== void 0 && width.default ? _reduceInstanceProperty(_context = _Object$keys(width)).call(_context, function (all, key) {
        if (key === 'default') {
          all.width = "".concat(width[key] / columns * 100, "%");
        } else {
          all[key] = {
            width: "".concat(width[key] / columns * 100, "%")
          };
        }

        return all;
      }, {}) : {
        width: "".concat(width / columns * 100, "%")
      }
    });
  }, // eslint-disable-next-line
  [columns, memWidth]);
  return /*#__PURE__*/React.createElement(Box, _extends({
    flexDirection: "column",
    flexWrap: "wrap"
  }, s.with('container')({
    style: style,
    className: cx(className, styles === null || styles === void 0 ? void 0 : styles.box),
    paddingLeft: padding,
    paddingRight: padding
  }), props, {
    ref: ref
  }));
});
export default Column;